import { useState } from 'react'

import { CookiePreferencesDialog } from './CookiePreferencesDialog'
import { useConsent } from './useConsent'

// The CPRA-mandated wording.
const LABEL = 'Do Not Sell or Share My Personal Information'
// CCPA § 7025(c)(6): a GPC visitor must see the signal was processed.
const HONORED = 'Opt-Out Request Honored'

interface CookiePreferencesLinkProps {
  className?: string
}

export function CookiePreferencesLink({
  className,
}: CookiePreferencesLinkProps) {
  const consent = useConsent()
  const [open, setOpen] = useState(false)
  const honored = consent?.gpc && !consent.state.advertising
  return (
    <>
      {honored && <span className="opacity-70">{HONORED}</span>}
      <button type="button" onClick={() => setOpen(true)} className={className}>
        {LABEL}
      </button>
      <CookiePreferencesDialog open={open} onOpenChange={setOpen} />
    </>
  )
}
